import { Dimmer, Loader } from 'semantic-ui-react';

export const ComponentLoader = () => (
  <Dimmer active>
    <Loader active inline size="large" />
  </Dimmer>
);
